module.exports = __webpack_public_path__ + "img/dashboard.6774d349.svg";